<template>
	<div>
		<div class="nav-back"></div>
		<div
			class="navbar fixed"
			:class="{ mobile: isMobile, collapsed: isCollapsed }"
			@click.stop="closeDropdown"
		>
			<div v-if="isMobile" class="navbar-brand">
				<a
					role="button"
					class="navbar-burger back"
					aria-label="menu"
					aria-expanded="false"
					@click="navigateBack"
				>
					<i class="fas fa-arrow-left" />
				</a>
				<customer-picker-button/>
				<a
					role="button"
					class="navbar-burger"
					aria-label="menu"
					aria-expanded="false"
					@click="openMenu"
				>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>
			<div v-if="!isMobile" class="navbar-menu">
				<div class="navbar-start">
					<customer-picker-button/>
				</div>
				<div class="navbar-end">
					<div class="navbar-item filler"></div>
					<div class="edge-container">
						<div class="edge-right" />
					</div>
					<div class="navbar-item">
						<p>Välkommen{{ getUser ? ", " + getUser.firstName : "" }}</p>
						<div class="box circle" @click.stop="toggleDropdown">
							<i class="fas fa-user"></i>
						</div>
					</div>
				</div>
			</div>
			<transition name="slide-down">
				<div class="menu absolute" v-if="showDropdown">
					<ul class="menu-list">
						<li @click="logout">
							<a><i class="fas fa-sign-out-alt" />Logga ut</a>
						</li>
					</ul>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import CustomerPickerButton from '@/components/customer/customer-picker-button';
import { mapGetters } from 'vuex';

export default {
	components: {
		CustomerPickerButton
	},

	props: {
		closeMenu: Boolean
	},

	data() {
		return {
			showDropdown: false
		};
	},
	computed: {
		...mapGetters('appStore', ['isMobile', 'isCollapsed']),
		...mapGetters('user', ['getUser'])
	},
	watch: {
		closeMenu: {
			handler: function() {
				if (this.closeMenu) {
					this.showDropdown = false;
				}
			}
		}
	},
	methods: {
		toggleDropdown() {
			this.showDropdown = !this.showDropdown;
			this.$emit('showDropdown', this.showDropdown);
		},
		closeDropdown() {
			this.showDropdown = false;
			this.$emit('showDropdown', this.showDropdown);
		},
		logout() {
			this.$emit('logout');
		},
		openMenu() {
			this.$emit('openMenu');
		},
		navigateBack() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";

.nav-back {
  height: $navbar-height;
  background-color: $navbar-background;
  width: 100%;
  top: 0px;
  position: fixed;
  z-index: 3;
}
.navbar.fixed {
  background-color: transparent;
  height: 0;
  width: calc(100% - #{$menu-width});
  top: 0px;
  left: $menu-width;
  &.collapsed {
    left: $menu-collapsed-width;
    width: calc(100% - #{$menu-collapsed-width});
  }
  position: fixed;
  //border-bottom: 0.1rem solid $navbar-border;
  z-index: 9;
}
.navbar.fixed.mobile {
  width: 100vw;
  left: 0;
}
.navbar-end {
  margin-left: 20px;
  background-color: $navbar-end-background;
  position: relative;
  z-index: 12;
  .navbar-item {
    background-color: $navbar-end-background;
    font-size: 14px;
  }
  .navbar-item.light {
    padding-left: 18px;
    background-color: $navbar-background;
  }
  .navbar-item.light {
    width: 50px;
    cursor: pointer;
  }
  .navbar-item.light:hover {
    background-color: $navbar-item-hover;
    i {
      color: $white;
    }
  }
  .navbar-item.filler {
    background-color: $navbar-background;
    width: 40px;
  }
}

.navbar-item p {
  color: $navbar-color;
}
.edge-container {
  position: relative;
}
.edge-right {
  position: absolute;
  transform: skew(-30deg);
  right: -20px;
  background-color: $navbar-end-background;
  width: 40px;
  height: 100%;
}
.navbar-start {
  width: calc(100% - 240px);
  background-color: transparent;
  .navbar-item:first-child {
    width: 200px;
  }
  .navbar-item:nth-child(2) {
    margin-left: auto;
  }
  .navbar-item {
    padding-left: 18px;
    background-color: $navbar-background;
  }
  .navbar-item:not(.search) {
    width: 50px;
    cursor: pointer;
  }
  .navbar-item:not(.search):hover {
    background-color: $navbar-item-hover;
    i {
      color: $white;
    }
  }
}
.navbar-item .box.circle {
  border-radius: 50px;
  background-color: $info;
  color: $white;
  margin-left: 10px;
  height: 20px;
  padding: 17px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.navbar-item .box.circle:hover {
  background-color: $info-active;
  color: $white;
}
.navbar-item .box.circle i {
  position: absolute;
  right: 6px;
  bottom: -1px;
  font-size: 26px;
  color: $white;
}
.menu.absolute {
  width: 150px;
  background-color: $navbar-background;
  position: absolute;
  right: 0;
  top: $navbar-height;
  border: 1px solid $navbar-border;
  z-index: 10;
  border-top: none;
}
li a {
  color: $navbar-color;
  font-size: 13px;
  border-radius: 0;
}
li a:hover {
  background-color: $info;
  color: $white;
}
li a:hover i {
  color: $white;
}
li a i {
  margin-right: 10px;
}
.navbar-brand {
  width: 100%;
}
.navbar-burger {
  color: $info-active;
  display: block;
}
.navbar-burger.back {
  text-align: center;
  margin-left: 0;
  i {
    font-size: 16px;
    padding-top: calc(50% - 8px);
  }
}

.input.is-small.search {
  background-color: $navbar-end-background;
  border-color: $navbar-end-background;
  border-radius: 15px;
  color: $navbar-color;
}
.icon.search i {
  color: $info-active;
}
.icon.clear {
  pointer-events: initial !important;
  cursor: pointer !important;
}
</style>
